import { render, staticRenderFns } from "./CollectedReference.vue?vue&type=template&id=8ce62f08&scoped=true&"
import script from "./CollectedReference.vue?vue&type=script&lang=js&"
export * from "./CollectedReference.vue?vue&type=script&lang=js&"
import style0 from "./CollectedReference.vue?vue&type=style&index=0&id=8ce62f08&prod&scoped=true&lang=css&"
import style1 from "./CollectedReference.vue?vue&type=style&index=1&id=8ce62f08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce62f08",
  null
  
)

export default component.exports